module.exports = __webpack_public_path__ + "static/media/photo268.cec42b46.jpg";